import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const JourneyPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 600px) {
    width: 100%;
    width: min(300px, 100%);
    align-items: stretch;
  }
`;

export const ChevronIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${colors.fontSecondary};
  transition: transform 0.15s ease;
`;

export const PillIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${colors.fontPrimary};
  flex-shrink: 0;
`;

export const CategoryOption = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  width: 100%;
  padding: ${space[3]} ${space[4]};
  background: ${({ $active }) => ($active ? colors.lighterGrey : 'transparent')};
  border: none;
  border-radius: ${layout.borderRadiusMd};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${({ $active }) => ($active ? fonts.weight.semiBold : fonts.weight.medium)};
  color: ${colors.fontPrimary};
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const CategoryThumb = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[8]};
  height: ${space[8]};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.lighterGrey};
  overflow: hidden;
`;

export const CategoryThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;
